import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LoaderService } from "./loader.service";
import { EnvironmentService } from "./environment.service";
import { map, Observable, tap } from "rxjs";
import { ActionResult, FetchBankRequest, BankData } from "@model";

@Injectable({ providedIn: 'root' })
export class PaymentService {
  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private environmentService: EnvironmentService
  ) {}

  fetchBankData(request: FetchBankRequest, hideLoading?: boolean): Observable<BankData | null> {
    if (!hideLoading) this.loaderService.startLoading();
    return this.http.post<ActionResult<BankData>>(
      `${this.environmentService.getApiUrl()}/api/public/payment/bankData`, request
    ).pipe(
      tap(() => !hideLoading && this.loaderService.dismissLoading()),
      map(value => value?.result ?? null)
    );
  }
}
